import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Zoom (TBD)", -1)
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "Topic"),
    /*#__PURE__*/_createElementVNode("td", null, "Host"),
    /*#__PURE__*/_createElementVNode("td", null, "Start Time"),
    /*#__PURE__*/_createElementVNode("td", null, "End Time"),
    /*#__PURE__*/_createElementVNode("td", null, "duration"),
    /*#__PURE__*/_createElementVNode("td", null, "Link"),
    /*#__PURE__*/_createElementVNode("td", null, "Record")
  ])
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

import { ref, onMounted } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import ToolServices from "../services/ToolServices";
import CreateMeeting from "../modals/ZoomIndex/CreateMeeting.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomIndex',
  setup(__props) {

const isLoading = ref(true);
const data = ref([]);
const createMeetingRef = ref<InstanceType<typeof CreateMeeting>>();
const fetchData = async () => {
  isLoading.value = true;

  isLoading.value = false;
};

const openCreateMeeting = () => {
  createMeetingRef.value?.show();
};

onMounted(() => {
  //   fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: openCreateMeeting,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Create Meeting ")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          disabled: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("End Current Meeting")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10))
      ])
    ]),
    _createVNode(CreateMeeting, {
      ref_key: "createMeetingRef",
      ref: createMeetingRef
    }, null, 512)
  ]))
}
}

})